<template>
  <!-- 右侧悬浮导航（Amber Logic 设计） -->
  <div class="floating-nav">
    <!-- 联系电话 -->
    <div class="floating-nav__item">
      <i class="material-icons floating-nav__icon">phone_in_talk</i>
      <span class="floating-nav__text">联系我们</span>
      <div class="floating-nav__preview floating-nav__preview--phone">
        <p class="floating-nav__preview-label">客服热线</p>
        <a href="tel:400-0811-363" class="floating-nav__preview-phone">
          400-0811-363
        </a>
      </div>
    </div>

    <!-- 商务微信 -->
    <div class="floating-nav__item">
      <i class="material-icons floating-nav__icon">chat</i>
      <span class="floating-nav__text">商务微信</span>
      <div class="floating-nav__preview">
        <img src="@/static/qrcode.jpg" alt="商务微信二维码" />
        <p class="floating-nav__preview-label">扫码添加商务微信</p>
      </div>
    </div>

    <!-- 合作申请 -->
    <div class="floating-nav__item" @click="handleApply">
      <i class="material-icons floating-nav__icon">handshake</i>
      <span class="floating-nav__text">合作申请</span>
    </div>

    <!-- 返回顶部 -->
    <transition name="fade-up">
      <div
        v-show="showBackToTop"
        class="floating-nav__item floating-nav__item--top"
        @click="scrollToTop"
      >
        <i class="material-icons floating-nav__icon">arrow_upward</i>
        <span class="floating-nav__text">回到顶部</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FloatingNav',

  data() {
    return {
      showBackToTop: false
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    handleApply() {
      if (this.$route.path !== '/apply') {
        this.$router.push('/apply')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-nav {
  position: fixed;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  z-index: $z-index-fixed;
  display: flex;
  flex-direction: column;
  gap: $spacing-sm;

  @include mobile {
    right: 12px;
    gap: 6px;
  }

  &__item {
    width: 72px;
    height: 72px;
    background-color: $bg-white;
    border: 1px solid $border-color;
    border-radius: $border-radius-lg;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    @include flex-center;
    flex-direction: column;
    gap: 2px;
    cursor: pointer;
    transition: all $transition-normal;
    position: relative;

    @include mobile {
      width: 56px;
      height: 56px;
    }

    &:hover {
      background-color: $primary-color;
      border-color: $primary-color;
      transform: translateX(-4px);
      box-shadow: 0 12px 28px rgba($primary-color, 0.28);

      .floating-nav__icon {
        color: $on-primary;
        transform: scale(1.1);
      }

      .floating-nav__text {
        color: $on-primary;
      }

      .floating-nav__preview {
        opacity: 1;
        visibility: visible;
        transform: translate(-12px, -50%);
      }
    }

  }

  &__icon {
    font-size: 26px !important;
    color: $primary-color;
    transition: all $transition-normal;

    @include mobile {
      font-size: 20px !important;
    }
  }

  &__text {
    font-size: 11px;
    color: $text-primary;
    font-weight: $font-weight-medium;
    text-align: center;
    line-height: 1.2;
    transition: color $transition-normal;
    white-space: nowrap;

    @include mobile {
      font-size: 9px;
    }
  }

  &__preview {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translate(0, -50%);
    margin-right: $spacing-md;
    background-color: $bg-white;
    padding: $spacing-md;
    border-radius: $border-radius-md;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: all $transition-normal;
    min-width: 180px;

    @include mobile {
      display: none;
    }

    img {
      width: 160px;
      height: 160px;
      object-fit: cover;
      border-radius: $border-radius-sm;
      display: block;
      background-color: $bg-surface-low;
    }

    &-label {
      margin: $spacing-sm 0 0;
      text-align: center;
      font-size: $font-size-xs;
      color: $text-secondary;
      font-weight: $font-weight-medium;
    }

    &-phone {
      display: block;
      margin-top: $spacing-xs;
      text-align: center;
      font-size: $font-size-xl;
      font-weight: $font-weight-bold;
      color: $primary-color;
      letter-spacing: 0.5px;

      &:hover {
        color: $primary-active;
      }
    }

    &--phone {
      min-width: 200px;
    }

    &::after {
      content: '';
      position: absolute;
      right: -6px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid $bg-white;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
    }
  }
}

// 回到顶部的显示动画
.fade-up-enter-active,
.fade-up-leave-active {
  transition: all $transition-normal;
}

.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
